import { render, staticRenderFns } from "./zhen.vue?vue&type=template&id=1656fcaf&scoped=true&"
import script from "./zhen.vue?vue&type=script&lang=js&"
export * from "./zhen.vue?vue&type=script&lang=js&"
import style0 from "./zhen.vue?vue&type=style&index=0&id=1656fcaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1656fcaf",
  null
  
)

export default component.exports